import _ from 'lodash'
import { SEVERITY_ERROR, SEVERITY_WARNING, SEVERITY_SUCCESS, SEVERITY_INFO } from './constants'

// const autoIncrementingId = 0

// function getNextId() {
//     // Just to make sure we never reach integer overflow
//     autoIncrementingId = autoIncrementingId < 10000 ? autoIncrementingId + 1 : 0
//     return autoIncrementingId
// }

// All notifications are built like this
const baseToast = {
    // A unique identifier
    id: '',

    // Imagine you have a notificationin the settings queue. It shows up when you have the
    // settings menu open. Then you close the settings menu and it disappears. Now you open the
    // settings menu again and it is still there, thus it is persistent. It only goes away when you
    // click on it to dismiss it
    persistent: false,

    // queue: ...
    queue: 'normal',

    isMessage: false,

    alwaysOnTop: false,

    // There are four supported severity types ['error', 'success', 'warning', 'info']
    // This setting determines look (css)
    severity: 'warning',

    // This controls where on the screen the notification should appear
    // We currently always use 'tr' (top-right)
    position: 'topRight',

    // Is the notification dismissible (can it be clicked away)?
    dismissible: true,

    // Should the notification disappear after x milliseconds?
    timeout: false,

    // How often have we recieved this notification
    count: 1,

    // How often have we recieved this notification since last dismissal
    countSinceLastDismissal: 1,

    // This is used by messages of the day so that we have access
    // to message specific data
    motd: null,

    // Message specific, so that we never dismiss the latest message, only hide it when
    // the user dismisses it. Then we show it again when the user chooses to open up the
    // notifications menu
    visible: true,

    dismissed: null,

    // Has this toast been seen (interesting for messages)
    // Could be used for toasts that are not dismissible as well...
    seen: false,

    title: '',

    content: '',
}

function getTimeout(severity, timeout) {
    const defaultTimeout = 5000

    // No timeout provided
    if (timeout == null) {
        const success = severity === SEVERITY_SUCCESS
        return success ? defaultTimeout : false
    }

    // Is a number provided?
    if (typeof timeout === 'number') {
        // 0 equals no timeout
        if (timeout === 0) {
            return false
        }
        // Only allow values between 1 and 60 seconds
        if (timeout < 1000 || timeout > 60000) {
            return defaultTimeout
        }
        return timeout
    }

    // Is only a true value provided?
    if (timeout === true) {
        return defaultTimeout
    }

    // In all other cases, return false
    return false
}

function getSeverity(severity) {
    const severityTypes = [SEVERITY_ERROR, SEVERITY_INFO, SEVERITY_WARNING, SEVERITY_SUCCESS]

    if (severityTypes.indexOf(severity) < 0) {
        return SEVERITY_INFO
    }

    return severity
}

// DJB2 Hashing Algorithm
// https://stackoverflow.com/a/7616484/404479
// This function is used to get "unique" notificationId based on
// a string
export function toHashCode(input) {
    let hash = 0
    let i
    let chr
    if (input.length === 0) return hash
    for (i = 0; i < input.length; i++) {
        chr = input.charCodeAt(i)
        hash = (hash << 5) - hash + chr // eslint-disable-line
        // eslint-disable-next-line
        hash |= 0 // Convert to 32bit integer
    }
    // eslint-disable-next-line
    return `0000000${(hash >>> 0).toString(16)}`.substr(-8)
}

export function createToast(options, severity, queue = null) {
    const now = +new Date()

    // Start by seting all values to default
    const result = {
        ...baseToast,
        created: now,
        updated: now,
        queue: queue != null ? queue : 'normal',
        severity: getSeverity(severity),
        title: '',
        content: '',
    }

    // Set default timeout based on severity only
    result.timeout = getTimeout(result.severity)

    // Nothing more we can do here
    if (options == null) {
        return result
    }

    // Update the title and content
    if (typeof options === 'string') {
        result.title = ''
        result.content = options
    } else {
        result.title = options.title || ''
        result.content = options.content || ''
    }

    // Get the options I am going to work with for easier access
    const { id, timeout, persistent, alwaysOnTop } = options

    // Set the timeout, if anything is supplied
    if (timeout != null) {
        result.timeout = getTimeout(result.severity, timeout)
    }

    // Set the id
    if (id !== undefined && id != null && id !== '') {
        result.id = id
    } else {
        // If id is missing, create one from a hash of the message
        result.id = toHashCode(result.content)
    }

    // Set persistence
    if (persistent !== undefined) result.persistent = persistent

    // Set the always on top availabiliy
    if (alwaysOnTop !== undefined) result.alwaysOnTop = alwaysOnTop

    return result
}

function toMessageToast(base, message) {
    return {
        // First the base
        ...base,

        // Then set message specific paramaters
        isMessage: true,
        motd: {
            intellectualProperty: message.intellectualProperty,
            created: message.created,
            updated: message.updated,
            version: message.version,
            timeStamp: message.timeStamp,
        },
        id: message.id,
        title: message.title,
        content: message.content,
        seen: message.seen == null ? false : message.seen,
        visible: message.seen == null ? true : !message.seen,
    }
}

export function createMessageToast(message, options) {
    return toMessageToast(
        // Start by creating a standard toast
        createToast(options, SEVERITY_INFO, 'normal'),
        message,
    )
}

export function createMessageToasts(messages) {
    // Return an empty array if no messages are given
    if (messages == null || messages.lenght < 1) {
        return []
    }

    // Start by creating a standard toast that will
    // be the base of all the toasts
    const base = createToast({}, SEVERITY_INFO, 'normal')

    // Now reduce the messages
    return _.reduce(
        messages,
        (toasts, message) => {
            // First map into a toast
            // console.log('from localforage')
            const toast = toMessageToast(base, message)
            toast.localized = message.localized

            // Then add the toast to our list of toasts
            toasts.push(toast)
            return toasts
        },
        [],
    )
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/api.js